@if (isSidebarOpen) {
  <app-side-bar-products (sidebarToggle)="onSidebarToggle($event)"
  [currentUser]="currentUser"></app-side-bar-products>
}
<div class="main-content">
  <div class="app-side-menu-wrapper">
    <app-side-menu></app-side-menu>
  </div>
  <div class="w-100 d-flex">
    <div class="d-flex flex-column w-100">
      <app-top-menu></app-top-menu>
      @if (this.currentUser.role !== 'Laboratorio') {
        <div class="div-top-products-btn">
          <div (click)="onSidebarToggle(true)" class="top-produtos">
            <span>
              Smart list
            </span>
          </div>
        </div>
      }
      @if (isLoading) {
        <div class="loading-animation">
          <app-loading></app-loading>
        </div>
      } @else {
        <div class="d-flex flex-column w-100 position-relative content">
          <div class="d-flex flex-row flex-wrap justify-content-between mb-2">
            <div class="d-flex flex-row filter-left justify-content-center fit-content">
              <h2 class="ml-3">Favoritos</h2>
            </div>
            <div class="filter-right d-flex flex-row order">
              Ordenar:
              <mat-form-field class="select-box mr-2">
                <mat-select [(value)]="orderByOption" (valueChange)="sortProducts()">
                  <mat-select-trigger>
                    @if (orderByOption !== 'none') {
                      {{ orderByOption.includes('preco') ? 'Preço' : 'Stock' }}
                      @if (orderByOption === 'preco-mais') {
                        <img
                          src="../../../assets/Icons/dashboard-arrow-up-black.png" alt="imagem" />
                      }
                      @if (orderByOption === 'preco-menos') {
                        <img
                          src="../../../assets/Icons/dashboard-arrow-down-black.png" alt="imagem" />
                      }
                      @if (orderByOption === 'stock-menos') {
                        <img
                          src="../../../assets/Icons/dashboard-arrow-down-black.png" alt="imagem" />
                      }
                      @if (orderByOption === 'stock-mais') {
                        <img
                          src="../../../assets/Icons/dashboard-arrow-up-black.png" alt="imagem" />
                      }
                    }
                  </mat-select-trigger>
                  <mat-option value="none">Nenhum</mat-option>
                  <mat-option value="preco-mais">
                    Preço
                    <img src="../../../assets/Icons/dashboard-arrow-up-black.png" alt="imagem" class="option-icon" />
                  </mat-option>
                  <mat-option value="preco-menos">
                    Preço
                    <img src="../../../assets/Icons/dashboard-arrow-down-black.png" alt="imagem" class="option-icon" />
                  </mat-option>
                  <mat-option value="stock-menos">
                    Stock
                    <img src="../../../assets/Icons/dashboard-arrow-down-black.png" alt="imagem" class="option-icon" />
                  </mat-option>
                  <mat-option value="stock-mais">
                    Stock
                    <img src="../../../assets/Icons/dashboard-arrow-up-black.png" alt="imagem" class="option-icon" />
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="results" matTooltip="{{ totalItems }} resultados" [matTooltipPosition]="'above'"
                [matTooltipShowDelay]="'500'" [matTooltipHideDelay]="'100'">
                <span>{{ totalItems }}</span>
                <img src="../../../assets/Icons/shopping-basket-line.png" alt="">
              </div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-between align-items-center align-self-stretch mt-2">
            <div class="products-grid">
              @for (product of shopItems; track product) {
                <app-product-shop (favoriteChange)="handleFavoriteChange($event)"
                [product]="product" [inFavorite]="true" (isModalOpen)="isProdModalOpen($event)"></app-product-shop>
              }
            </div>
          </div>
          @if (shopItems.length < totalItems) {
            <div class="d-flex justify-content-center mt-4">
              <div style="width: fit-content">
                @if (!isLoading) {
                  <button class="btn-more" [disabled]="isLoadingMore" (click)="loadMore()">
                    @if (isLoadingMore) {
                      <mat-spinner diameter="20"></mat-spinner>
                    }
                    <span>Mostrar mais resultados</span>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
      <app-footer></app-footer>
    </div>
  </div>
</div>